import React, { useState } from 'react'
import { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { ReactComponent as Seperator } from '../../assets/icons/ui/RightArrow.svg'
import AuthService from '../../services/auth'
import Button from '../Button'

const invAcct = "InventoryAccount"

const Signout = (props) => {
  const [ isInventory, setIsInventory ] = useState(false)
  const { location: { pathname } } = props
  const pathNames = pathname.split("/").filter(x => x)

  useEffect(() => {
    if (pathNames[0] === invAcct) {
      setIsInventory(true)
    } else {
      setIsInventory(false)
    }
  }, [pathNames])

  const currentLoggedInUser = new AuthService()
  
  const handleSignout = () => {
    currentLoggedInUser.logout()
  }

  return (
    <>
      {isInventory ? (
        <div className="sign-out-container">
          <Seperator className="sign-out-icon" />
          <Button
            className={`button -link-button-back -secondary back sign-out-button`}
            aria-label={`Sign Out`}
            data-a11y-focus="first"
            onClick={handleSignout}
          >Sign Out </Button>
        </div>
      ) : null}
    </>
  )
}

export default withRouter(Signout)
